import React, { useEffect, useState } from 'react';
import Popup from 'reactjs-popup';

import WatchlistActions from '../WatchlistActions/WatchlistActions';
import WatchlistDelete from '../WatchlistDelete/WatchlistDelete';
import WatchlistRename from '../WatchlistRenameModal/WatchlistRename';
import WatchlistSelection from '../WatchlistSelection/WatchlistSelection';
import { isMobileWidth } from '../../theme/layoutUtilities';
import {
    registerResizeHandler,
    unregisterResizeHandler
} from '../../utils/resize-handler';
import {
    WATCHLIST_ACTIONS,
    WATCHLIST_DELETE,
    WATCHLIST_RENAME,
    WATCHLIST_SELECTION
} from '../../utils/watchlist-settings';

const modalMap = {
    [WATCHLIST_ACTIONS]: <WatchlistActions />,
    [WATCHLIST_DELETE]: <WatchlistDelete />,
    [WATCHLIST_RENAME]: <WatchlistRename />,
    [WATCHLIST_SELECTION]: <WatchlistSelection />
};

const popUpStyleMobile = {
    borderRadius: '5px',
    padding: '4px',
    marginLeft: '32px',
    marginRight: '32px',
    width: '100%'
};

const popUpStyle = {
    borderRadius: '5px',
    margin: 'auto',
    width: '100%',
    maxWidth: '540px'
};

const desktopModals = [WATCHLIST_DELETE, WATCHLIST_RENAME];

const Modal = ({
    dispatchModal = () => {},
    dispatchWatchlist = () => {},
    modalToDisplay = false,
    watchlistName = '',
    watchlists = [],
    watchlistUuid = '',
    ...contentComponentProps
}) => {
    const ModalContentComponent = modalMap[modalToDisplay];
    const closeModal = () => dispatchModal(false);
    const [showModal, setShowModal] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(
        () => {
            function checkIsMobile() {
                setShowModal(
                    isMobileWidth() || desktopModals.includes(modalToDisplay)
                );
                setIsMobile(isMobileWidth());
            }
            checkIsMobile();
            registerResizeHandler(checkIsMobile);
            return () => unregisterResizeHandler();
        },
        [modalToDisplay]
    );

    return (
        showModal && (
            <Popup
                closeOnDocumentClick
                closeOnEscape
                contentStyle={isMobile ? popUpStyleMobile : popUpStyle}
                onClose={() => dispatchModal(false)}
                open={!!modalMap[modalToDisplay]}
            >
                {ModalContentComponent &&
                    React.cloneElement(ModalContentComponent, {
                        closeModal,
                        dispatchModal,
                        dispatchWatchlist,
                        isMobile,
                        isModal: true,
                        watchlists,
                        watchlistUuid,
                        watchlistName,
                        ...contentComponentProps
                    })}
            </Popup>
        )
    );
};

export default Modal;
